<template>
  <div class='EstoqueHeader'>
    <div style="width: 8%">
      <img-icon
      text="Imagem"
      :active="true"
      :optionsLabel="{ marginTop: '65px' }"
      />
    </div>
    <div class="c-name">Nome</div>
    <div class="c-status mobile-none">Status</div>
    <div class="c-estoque">Qtde</div>
    <div class="c-preco mobile-none">Preço</div>
    <div style="width: 10%" class="mobile-none">Categoria</div>
    <div style="width: 4%" class="mobile-none">
      <box-icon
      text="Tipo"
      :active="true"
      :optionsLabel="{ marginTop: '65px' }"
      />
    </div>
    <div style="width: 4%" class="mobile-none">
      <eyes-icon
      text="Visualizações"
      :active="true"
      :optionsLabel="{ marginTop: '65px' }"
      />
    </div>
    <div style="width: 10%" class="mobile-none">Data</div>
  </div>
</template>

<script>
import ImgIcon from '../Icons/ImgIcon.vue'
import BoxIcon from '../Icons/BoxIcon.vue'
import EyesIcon from '../Icons/EyesIcon.vue'
export default {
  name: 'EstoqueHeader',
  components: { ImgIcon, BoxIcon, EyesIcon }
}
</script>

<style scoped>
.EstoqueHeader {
  height: 6%;
  display: flex;
  align-items: center;
}

.c-name {
  width: 35%;
  text-align: left;
}

.c-status {
  width: 8%;
}

.c-preco {
  width: 8%;
}

.c-estoque {
  width: 10%;
}

@media (max-width: 500px) {
  .mobile-none {
    display: none;
  }
  .c-name {
    width: 70%;
  }
  .c-status {
    width: 20%;
  }
  .c-preco {
    width: 20%;
  }
  .c-estoque {
    width: 20%;
    text-align: right;
  }
}
</style>
